import Spacer from '../Spacer/Spacer.jsx'
import {getBaseImagePath} from "../../../../ui/catalog/Utils";

const BannerRepository = props => {
	const hasVideo = props.params.video || props.params.videoMob;

	return (
		<>
			<div className='mblock text-center elem-banner-rep'>
				<div className='w100'>
					{hasVideo ? (
						props.params.url && props.params.url !== '' ? (
							<a href={props.params.url}>
								<video
									src={getBaseImagePath() + props.params.video}
									autoPlay
									muted
									loop
									playsInline
									style={{width: '100%', height: 'auto', display: props.params.video ? 'block' : 'none'}}
									className="desk"
								/>
								<video
									src={getBaseImagePath() + props.params.videoMob}
									autoPlay
									muted
									loop
									playsInline
									style={{width: '100%', height: 'auto', display: props.params.videoMob ? 'block' : 'none'}}
									className="mob"
								/>
							</a>
						) : (
							<>
								<video
									src={getBaseImagePath() + props.params.video}
									autoPlay
									muted
									loop
									playsInline
									style={{width: '100%', height: 'auto', display: props.params.video ? 'block' : 'none'}}
									className="desk"
								/>
								<video
									src={getBaseImagePath() + props.params.videoMob}
									autoPlay
									muted
									loop
									playsInline
									style={{width: '100%', height: 'auto', display: props.params.videoMob ? 'block' : 'none'}}
									className="mob"
								/>
							</>
						)
					) : (
						props.params.url && props.params.url !== '' ? (
							<a href={props.params.url}>
								<picture>
									<source media="(max-width: 991px)" srcSet={getBaseImagePath() + props.params.imgmob} />
									<img src={getBaseImagePath() + props.params.img} alt={props.params.img} />
								</picture>
							</a>
						) : (
							<picture>
								<source media="(max-width: 991px)" srcSet={getBaseImagePath() + props.params.imgmob} />
								<img src={getBaseImagePath() + props.params.img} alt={props.params.img} />
							</picture>
						)
					)}
				</div>
			</div>
			<Spacer />
		</>
	)
}

export default BannerRepository
